import React from 'react';
import jump from 'jump.js';
import BankTransferFormKhipu from '@ui-components/bank-transfer-khipu/form/index';
import BankTransferSuccessPSE from '@ui-components/bank-transfer-pse/success/index';
import formatAmount from '@utils/amount-formatter';
import { createBankTransfer } from '@services/bank-transfer';
import { API_ERRORS, PAYMENT_CODES } from '@constants';
import { validateBankTransfer } from './validators';
import removeAccents from '@utils/remove-accents';
import language from '@language';
import './main.scss';

export default class BankTransferContainer extends React.Component<any, any> {
  sended: boolean;
    constructor(props) {
        super(props);
        this.sended = false;

        this.state = {
            fields: {
                client_number: '',
                property_name: '',
                holder_name: '',
                document: '',
                email: '',
                invoice_number: '',
                amount: '',
                conditions: false,
                payment_method_id: PAYMENT_CODES.KHIPU
            },
            errors: {}
        };
    }

    handleSubmit(fields) {
        this.sended = true;
        const { country } = this.props;
        const errors = validateBankTransfer(fields, this.props.country);

        /*Form validations*/
        if (Object.keys(errors).length > 0) {
            return this.setState({
                errors: Object.assign({}, this.state.errors, errors)
            });
        }

        /*Conditions validations*/
        if (!fields.conditions) {
            return this.setState({ errorMessage: 'Debes aceptar los términos y condiciones  para continuar' }, () => {
                jump('.bank-transfer.khipu #error-box', {
                    duration: 200,
                    offset: -100
                });
            });
        }

        const newFields = {
            ...fields,
            email: removeAccents(fields.email)
        }

        /*Send Request*/
        this.setState(
            {
                sending: true
            },
            () => {
                createBankTransfer({ fields: newFields, country, destinationBankCode: PAYMENT_CODES.KHIPU })
                    .then(({ data }) => {
                      console.log(data);
                        this.setState(
                            {
                                success: true
                            },
                            () => {
                               window.location.href = data.redirect_url;
                            }
                        );
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            const errorCode = error.response.data.err?.code;

                            if (errorCode === API_ERRORS.INVALID_INVOICE_NUMBER) {
                                return this.setState(prev => ({
                                    errors: { ...prev.errors, invoice_number: language.form_validation.must_be_ten_digits },
                                    sending: false
                                }));
                            }

                            if (errorCode === API_ERRORS.INVALID_DOCUMENT) {
                                return this.setState({
                                    errors: Object.assign({}, this.state.errors, {
                                        document: 'El valor ingresado no es válido'
                                    }),
                                    sending: false
                                });
                            }

                            if (errorCode === API_ERRORS.INVALID_BANK_TRANSFER) {
                                return this.setState(
                                    {
                                        errorMessage:
                                            'Hubo un error al envíar la solicitud, por favor intente de nuevo',
                                        sending: false
                                    },
                                    () => {
                                        jump('.bank-transfer.khipu #error-box', {
                                            duration: 200,
                                            offset: -100
                                        });
                                    }
                                );
                            }
                        }
                    });
            }
        );
    }

    handleChange(fields) {
        const valid = validateBankTransfer(fields, this.props.country);

        const formattedFields = {
            ...fields,
            amount: formatAmount(fields.amount)
        };

        this.setState({
            errors: valid,
            fields: formattedFields
        });
    }

    render() {
        const { errors, fields, sending, success, errorMessage, originBank, destinationBank } = this.state;
        return (
            <div>
                {!success && (
                    <BankTransferFormKhipu
                        errorMessage={errorMessage}
                        showValidations={this.sended}
                        sending={sending}
                        errors={errors}
                        fields={fields}
                        onChange={fields => this.handleChange(fields)}
                        onSubmit={fields => this.handleSubmit(fields)}
                    />
                )}

                {success && (
                    <BankTransferSuccessPSE fields={fields} originBank={originBank} destinationBank={destinationBank} />
                )}
            </div>
        );
    }
}
